import React, { useState } from 'react';
import { Box, Typography, IconButton, useTheme, useMediaQuery } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import UpdateCompanyDialogBox from './UpdateCompanyDialogBox';

const CompanyDetails = ({ companyData, selectedCompany, refetch }) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const [openDialog, setOpenDialog] = useState(false);

    const selectedCompanyData = companyData.find((company) => company.name === selectedCompany);

    const handleOpenDialog = () => setOpenDialog(true);
    const handleCloseDialog = () => setOpenDialog(false);

    return (
        <Box
            gridColumn={isSmallScreen ? 'span 12' : 'span 6'}
            gridRow="span 2"
            backgroundColor={theme.palette.background.paper}
            borderRadius="15px"
            position="relative"
            overflow="auto"
            sx={{
                boxShadow: '8px 8px 20px rgba(0, 0, 0, 0.1)',
            }}
        >
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h3" sx={{ color: theme.palette.text.white, m: '4%', fontWeight: 'bold' }}>
                    COMPANY DETAILS
                </Typography>
                <IconButton
                    sx={{
                        marginRight: '4%',
                        '&:focus': {
                            outline: 'none',
                        },
                    }}
                    onClick={handleOpenDialog}
                >
                    <EditIcon sx={{ color: theme.palette.text.white }} />
                </IconButton>
            </Box>

            {selectedCompanyData && (
                <Box sx={{ ml: '4%' }}>
                    <Typography variant="h4" gutterBottom>
                        <strong>Address:</strong> {selectedCompanyData.address}
                    </Typography>
                    <Typography variant="h4" gutterBottom>
                        <strong>City:</strong> {selectedCompanyData.city}
                    </Typography>
                    <Typography variant="h4" gutterBottom>
                        <strong>Country:</strong> {selectedCompanyData.country}
                    </Typography>
                    <Typography variant="h4" gutterBottom>
                        <strong>Industry:</strong> {selectedCompanyData.industry}
                    </Typography>
                    <Typography variant="h4" gutterBottom>
                        <strong>Contact Email:</strong> {selectedCompanyData.contactEmail}
                    </Typography>
                    <Typography variant="h4" gutterBottom>
                        <strong>Contact Phone:</strong> {selectedCompanyData.contactPhone}
                    </Typography>
                    <Typography variant="h4" gutterBottom>
                        <strong>Website:</strong>{' '}
                        <a href={selectedCompanyData.website} target="_blank" rel="noopener noreferrer">
                            {selectedCompanyData.website}
                        </a>
                    </Typography>
                </Box>
            )}

            <UpdateCompanyDialogBox openDialog={openDialog} handleCloseDialog={handleCloseDialog} companyData={selectedCompanyData} refetch={refetch} />
        </Box>
    );
};

export default CompanyDetails;
